import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 6a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3","key":"svg-0"}],["path",{"d":"M6 21h12a3 3 0 0 0 0 -6h-12a3 3 0 0 0 0 6z","key":"svg-1"}],["path",{"d":"M12 15v-8","key":"svg-2"}],["path",{"d":"M9 10l3 -3l3 3","key":"svg-3"}]]

const IconTransitionTop = createReactComponent('outline', 'transition-top', 'TransitionTop', __iconNode);

export default IconTransitionTop;